import { cn } from '@/lib/utils'

interface SectionDividerProps {
  className?: string
  /** Vertical margin - defaults to my-16 */
  spacing?: 'none' | 'sm' | 'md' | 'lg'
}

const spacingClasses = {
  none: '',
  sm: 'my-4',
  md: 'my-8',
  lg: 'my-16',
}

export function SectionDivider({ className, spacing = 'lg' }: SectionDividerProps) {
  return (
    <div className={cn('w-full max-w-6xl px-6 sm:px-12', spacingClasses[spacing], className)}>
      <div className="h-0.5 w-full bg-gradient-to-r from-transparent via-[#7ee2ff]/60 to-transparent" />
    </div>
  )
}
